// removed by extract-text-webpack-plugin
module.exports = {"dropdownLabel":"primaryDropdown__dropdownLabel--38btL","dropdownLabelTooltip":"primaryDropdown__dropdownLabelTooltip--pyaFH"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/FilterComponents/primaryDropdown.css
// module id = iflo
// module chunks = 0 2 3 4 6 7 10 13 14 15 16 17 18 20 25 28